import { GridCustomCellProps } from "@progress/kendo-react-grid";

const CallerCell = (props: GridCustomCellProps) => {
  if (!props.field || props.rowType !== 'data') return null;

  if (!props.dataItem.CallerName) {
    return <td {...props.tdProps}>{props.dataItem.CallerNumber}</td>;
  }

  return <td {...props.tdProps} title={props.dataItem.CallerNumber}>{props.dataItem.CallerName}</td>;
}

export default CallerCell;
